'use strict';

/**
 * On click of entire wrapper add the focus class
 */
let onClickSearchHandlers = function() {
	let $searchElement = $('.search-field-wrapper');
	let $searchField = $searchElement.find('input');
	let $closeSearchBtn = $searchElement.find('.fa-times');
	let $openSearchBtn = $searchElement.find('.fa-search');
	let $searchLi = $searchElement.find('li');
	let inputValue;
	let schoolsOrUse = window.location.host === 'schools.shmoop.com' ? 'schools' : 'use';

	$openSearchBtn.on('click', function() {
		inputValue = $searchField.val();

		if ($searchElement.hasClass('focus')) {
			window.location.href = 'https://' + schoolsOrUse + '.shmoop.com/search/?q=' + inputValue;
		} else {
			$searchField.focus();
			$searchElement.addClass('focus');
		}
	});

	$searchField.on('keyup', function(event) {
		inputValue = $searchField.val();

		if (event.keyCode === 13 && inputValue !== '') {
			window.location.href = 'https://' + schoolsOrUse + '.shmoop.com/search/?q=' + inputValue;
		}
	});

	$searchLi.on('click', function() {
		$searchField.focus();
		$searchElement.addClass('focus');
	});

	$closeSearchBtn.on('click', function() {
		$searchElement.removeClass('focus');
		$searchField.val('');
	});
};

/**
 * Generates and places the search html inside of class .search-field-wrapper
 */
let generateSearchHtml = function() {
	let $searchElement = $('.search-field-wrapper');
	let searchHtml = '<div class="row">' +
		'<div class="col-12 p-0">' +
			'<input type="text" placeholder="Search" class="form-control border-1" />' +
			'<i class="far fa-times"></i>' +
			'<li>Search</li>' +
			'<i class="far fa-search"></i>' +
		'</div><div class="search-label-mobile"><li>Search</li></div>' +
	'</div><!--end row-->';

	$searchElement.html(searchHtml);
	onClickSearchHandlers();
};

let init = function() {
	generateSearchHtml();
};

module.exports =  {
	init: init
};
